import { useAppSelector } from 'src/redux/app/app.hooks'
import { selectCurrentUser } from 'src/redux/auth'

// TEMPORARY: restrict the inventory page to these users until it is ready for wider release
const EMAIL_DOMAIN = 'voiapp.io'
const ALLOWED_USERNAMES = ['veronica.ginman', 'richard.loof', 'mei.yang', 'idil.tunga']
const ALLOWED_EMAILS = ALLOWED_USERNAMES.map(username => `${username}@${EMAIL_DOMAIN}`)

export const useCanViewBatteryInventory = () => {
    const email = useAppSelector(selectCurrentUser)?.email
    return !!email && ALLOWED_EMAILS.includes(email.toLowerCase())
}
